import ContentModule from "../../../../models/state/modules/module/ContentModule";

export function getId(contentModule: ContentModule) {
  return contentModule.id;
}
export function getParentId(contentModule: ContentModule) {
  return contentModule.parentId;
}
export function getModuleType(contentModule: ContentModule) {
  return contentModule.moduleType;
}
export function getModuleContent(contentModule: ContentModule) {
  return contentModule.content;
}

export function getModuleDifficulty(contentModule: ContentModule) {
  return contentModule.moduleDifficulty;
}
